import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../insightConfig/insightConfig';
import Dashboardleft from '../DashboardLeft/Dashboardleft';
import Dashboradeffect from '../EffectonLoad/Dashboardeffect';
import CivilButton from '../ReusableComponent/CIVIL/CivilButton/CivilButton';
import "./dashboard.css";
import SeoHelmets from '../SeoOptimazation/SeoHelmets';

function Dashborad() {
  const authtoken = localStorage.getItem('authtoken');
  const componentName = "dashboard";
  const civilheading = ""
  const [userData, setUserData] = useState([]);
  const [loadUserData, setLoadUserData] = useState(false);


  const alert = useAlert();
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location);
  const { moduleName } = location.state || {};
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${BASE_URL}/studentdashboard`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        setUserData(response?.data?.data);
      } catch (error) {
        alert.show(error?.response?.data?.message || 'Error fetching student dashboard data')
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
    window.scrollTo(0, 0);
  }, [loadUserData]);

  const formatExamType = (type) => {
    if (!type) return '';
    const t = type.toLowerCase();
    if (t === 'neet') return 'NEET';
    if (t === 'cuet') return 'CUET';
    if (t === 'ugc-net') return 'UGC-NET';
    if (t === 'civil services') return 'Civil Services';
    return type.toUpperCase();
  };

  if (!userData || userData.length === 0) {
    return <div><Dashboradeffect /></div>;
  }
  const userDtails = userData[0] || []

  return (
    <>
      <SeoHelmets 
        title="Student Dashboard - Insight IAS" 
        description="Your personalized student dashboard to manage courses, tests, and academic progress at Insight IAS Academy." 
        keywords="student dashboard, IAS exam tracker, test series results, Insight IAS academy"
      />
      <div className='Dashboard-background'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
              <Dashboardleft authtoken={authtoken} userDtails={userDtails} setLoadUserData={setLoadUserData} loadUserData={loadUserData} />
            </div>
            <div className='col-lg-9 col-md-12 col-sm-12'>
              <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                <button
                  className="btn btn-sm"
                  style={{
                     backgroundColor: '#17a2b8',         
                     color: 'white',
                     fontWeight: 'bold',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '5px',
                     padding: '4px 12px',
                     border: 'none',
                     borderRadius: '4px',
                     boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                     cursor: 'pointer'
                  }}
                  onClick={() => navigate(-1)}
                >
                  <SlArrowLeft /> Back
                </button>
                <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>
                  Student Dashboard {userDtails?.ExamType ? ` - ${formatExamType(userDtails.ExamType)}` : ''}
                </h2>
                <Link to={moduleName === 'neet' ? '/neet/about' : moduleName === 'cuet' ? '/cuet' : '/'} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Home</Link>
              </div>
              <CivilButton moduleName={moduleName} componentName={componentName} heading={civilheading} userDtails={userDtails} prePath={location?.state?.prePath} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Dashborad;
